<template>
  <b-form data-vv-scope="form_copy_product">

    <b-form-group v-if="product.hasOwnProperty('nombre')" label="Producto original">
      <b-form-input class="color-form-input-readonly" disabled :value="product.nombre"></b-form-input>
    </b-form-group>


    <b-form-group label="Nombre del producto">
      <b-form-input name="nombre" v-model="payload.name" v-validate="'required|validate_different'"/>
      <span class="text-danger span-error small"
            v-text="errors.first('form_copy_product.nombre')"/>
    </b-form-group>


    <div class="text-right mt-5">
      <b-button @click="closeModal()" class="mx-1" size="md" v-b-modal.modalDuplPr> Cancelar</b-button>
      <b-button class="mx-1" size="md" variant="primary" @click="duplicProduct()"><i class="fa fa-save"></i> Guardar
      </b-button>
    </div>


  </b-form>


</template>

<script>
import Swal from "sweetalert2";
import {mapActions} from "vuex";


export default {
  props: ['product'],
  name: "ModalDuplicProduct",
  data() {
    return {
      payload: {
        id: null,
        name: '',
      }
    }
  },
  created() {
    this.customRuleVeeValidate();
    this.payload.id = this.product.id;
    this.payload.name = this.product.nombre;
  },
  methods: {
    ...mapActions('productos', ['saveCopiedProduct']),
    async duplicProduct() {
      const isValid = await this.validateData();
      if (isValid) {
        await this.showModalConfirm();
      }
    },
    showModalConfirm() {
      Swal.fire({
        title: "Duplicar producto",
        text: "¿Está seguro de duplicar el producto?",
        icon: "warning",
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        confirmButtonColor: "#097b83",
        cancelButtonColor: "#d33",
        confirmButtonText: "Duplicar",
      }).then(async (result) => {
        if (result.isConfirmed === false) return;
        await this.saveCopiedProduct(this.payload).then(async ({message, data}) => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: message,
            showConfirmButton: false,
            timer: 3000
          });
          await this.$router.push(`productos/${data}`);
        });

      });
    },
    closeModal() {
      this.$bvModal.hide('modal_dupl_product');
    },
    async validateData() {
      const data = await this.$validator
          .validateAll('form_copy_product')
          .then(async (result) => {
            if (!result) return false;
            return true;
          });
      return data;
    },
    customRuleVeeValidate(){
      let self = this
      this.$validator.extend('validate_different', {
        params: ['target'],
        getMessage() {
          return `El nombre del producto debe ser diferente a ${self.product.nombre}`;
        },
        validate(value) {
          return value.toLowerCase() !== self.product.nombre.toLowerCase()
        },
      });
    }
  }
}
</script>

<style scoped>
.color-form-input-readonly {
  color: #000000 !important;
  background-color: #FAFAFA;
}
</style>
